import React from "react";
import { Box, CircularProgress, Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Text from "./Text";

export function MainCircularProgress({ color, textId }) {
  return (
    <>
      <Box
        display="flex"
        flex="auto"
        justifyContent="center"
        className="appear-anim"
        alignItems="center"
      >
        <Box style={{ textAlign: "center" }}>
          <CircularProgress
            aria-label="Updating application"
            size={100}
            style={{ color: color }}
            thickness={1.5}
          />
          {textId && (
            <Grid
              item
              className={"fade-in-anim"}
              style={{
                animationTimingFunction: "cubic-bezier(1.00, 0.00, 0.92, 0.01)",
                animationDuration: "2s",
                height: "0",
                paddingInline: "1rem",
                marginTop: "20px",
                marginBottom: "-20px",
              }}
            >
              <Typography variant="body2" color="textSecondary">
                <Text tId={textId} />
              </Typography>
            </Grid>
          )}
        </Box>
      </Box>
    </>
    // <Grid style={{ textAlign: "center", height: "100%" }}>
    //   <CircularProgress
    //     className={"transition-all"}
    //     size={100}
    //     thickness={1.5}
    //     style={{
    //       margin: "-20px 0 0 0",
    //       color: color
    //     }}
    //   />
    //
    // </Grid>
  );
}
